import ProductCard from "./ProductCard";
import type { Product } from "@/data/products";

interface Props {
  products: Product[];
  title?: string;
}

const ProductGrid = ({ products, title }: Props) => (
  <div className="flex-1">
    {title && (
      <h2 className="mb-6 font-display text-2xl font-bold text-foreground">{title}</h2>
    )}
    <div className="grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-3 xl:grid-cols-4">
      {products.map((p) => (
        <ProductCard key={p.id} product={p} />
      ))}
    </div>
  </div>
);

export default ProductGrid;
